var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        {
          staticClass: "gg-card-header"
        },
        [
          _c(
            "h3",
            {
              staticClass: "mb-0"
            },
            [_vm._v("Domain Change")]
          ),
          _c(
            "span",
            {
              staticClass: "text--secondary text-sm"
            },
            [_vm._v("Change the primary domain of your hosting account.")]
          )
        ]
      ),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            {
              attrs: {
                dense: ""
              }
            },
            [
              !_vm.hasActiveRequest
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v(" Enter the domain you want to switch to. ")
                      ]),
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                              return _vm.submitForm($event)
                            }
                          }
                        },
                        [
                          _c("gg-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  url: true,
                                  required: true
                                },
                                expression: "{ url: true, required: true }"
                              }
                            ],
                            attrs: {
                              label: "Domain Name",
                              name: "domain-name",
                              "aria-label": "Domain Name",
                              "data-vv-as": "Domain Name",
                              "error-messages": _vm.errors.collect(
                                "domain-name"
                              )
                            },
                            model: {
                              value: _vm.newDomain,
                              callback: function callback($$v) {
                                _vm.newDomain = $$v
                              },
                              expression: "newDomain"
                            }
                          }),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                loading: _vm.loading
                              },
                              on: {
                                click: _vm.submitForm
                              }
                            },
                            [_vm._v("Submit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c(
                        "v-alert",
                        {
                          staticStyle: {
                            color: "black"
                          },
                          attrs: {
                            type: "warning",
                            dense: ""
                          }
                        },
                        [
                          _vm._v(
                            " Your domain change request is pending and will be processed within a few minutes. "
                          )
                        ]
                      ),
                      _vm.requestData
                        ? _c("p", [
                            _c("b", [_vm._v("Original domain:")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.requestData.domain_original) +
                                " "
                            ),
                            _c("br"),
                            _c("b", [_vm._v("New domain:")]),
                            _vm._v(
                              " " + _vm._s(_vm.requestData.domain_new) + " "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }